var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgConcierge = function SvgConcierge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.517 10.57v-.075a10.495 10.495 0 1 0-20.99 0v.075A3.748 3.748 0 0 0 .53 14.243v2.998a3.748 3.748 0 0 0 3.748 3.748h1.5a2.249 2.249 0 0 0 2.248-2.248v-5.997a2.249 2.249 0 0 0-2.248-2.25h-.75a8.996 8.996 0 1 1 17.991 0h-.75a2.249 2.249 0 0 0-2.248 2.25v5.997a2.248 2.248 0 0 0 2.248 2.248h1.08a7.93 7.93 0 0 1-6.132 5.803 2.233 2.233 0 0 0-2.024-1.29h-3.119a2.249 2.249 0 0 0 0 4.498h3.119a2.249 2.249 0 0 0 2.189-1.724 9.4 9.4 0 0 0 7.496-7.496 3.748 3.748 0 0 0 2.594-3.554v-2.998a3.748 3.748 0 0 0-2.954-3.658Zm-18.74 1.424a.75.75 0 0 1 .75.75v5.997a.75.75 0 0 1-.75.75h-1.5a2.249 2.249 0 0 1-2.249-2.25v-2.998a2.249 2.249 0 0 1 2.25-2.249h1.499Zm9.415 16.492h-3.119a.75.75 0 1 1 0-1.5h3.119a.75.75 0 0 1 0 1.5Zm10.825-11.26a2.249 2.249 0 0 1-2.25 2.25h-1.499a.75.75 0 0 1-.75-.75v-5.997a.75.75 0 0 1 .75-.75h1.5a2.248 2.248 0 0 1 2.248 2.249v2.998Z",
    fill: "#102B3F"
  })));
};

export default SvgConcierge;